import { computed, defineComponent } from 'vue';
import InputDropzoneFile from '@/components/inputs/InputDropzoneFile.vue';
export default defineComponent({
    components: { InputDropzoneFile },
    props: {
        modelValue: Array,
        placeholder: String,
        accept: String
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const templateOptions = {
            maxFiles: 1,
            accept: props.accept || '',
            maxSize: 1024 * 1024 * 2 // 2 MB
        };
        const handleTemplateChange = (files) => {
            value.value = files;
        };
        return {
            value,
            templateOptions,
            handleTemplateChange
        };
    }
});
